import { render } from "./main-novelty.vue?vue&type=template&id=6b5c1db1&bindings={}"
import script from "./main-novelty.vue?vue&type=script&lang=ts"
export * from "./main-novelty.vue?vue&type=script&lang=ts"

import "./main-novelty.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script